<template>
  <div class="container p-x-3:mo">
    <div class="TITLE p-l-3:mo">Tools & Offers</div>
    <div class="layout">
      <div class="layout-item">
        <div class="SUB-TITLE m-l-0:mo">Tools</div>
        <div class="DIVIDER w-100:mo"/>
        <div v-for="item in toolsMenu" v-bind:key="item[0]">
          <a
              class="INFO-LABEL"
              :href="item[1]"
              target="_blank"
              rel="noopener noreferrer"
              selenium="tools-link">
            {{item[0] }}
            <vk-icon name="external-link" class="EXTERNAL-ICON p-l-1" />
          </a>

          <div class="DIVIDER w-100:mo"/>
        </div>
      </div>
      <div class="layout-item">
        <div class="SUB-TITLE m-l-0:mo m-t-2:mo">Offers</div>
        <div class="DIVIDER w-100:mo"/>
        <div v-for="item in offersMenu" v-bind:key="item[0]">
          <a
              class="INFO-LABEL"
              :href="item[1]"
              target="_blank"
              rel="noopener noreferrer"
              selenium="tools-link">
            {{item[0] }}
            <vk-icon name="external-link" class="EXTERNAL-ICON p-l-1" />
          </a>
          <div class="DIVIDER w-100:mo"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
export default {
  name: 'tools-offers',
  data () {
    return {
      toolsMenu: [
        ['How Pro Referral works', `${this.$runtimeConstants.SALESFORCE_ACCOUNT_REDIRECT_DOMAIN}/prohelpcenter/s/article/Pro-Referral-training-video?source=app-how-it-works-menu`],
        ['Behr Hub rep locator', 'https://www.behr.com/pro/contact-a-rep?utm_source=proreferral.com&utm_medium=referral&utm_campaign=proreferral%20%5bbehr.com%5d'],
        ['Rent tools, trucks, and large equipment', 'https://www.homedepot.com/c/tool_and_truck_rental'],
        ['Shop Home Depot online', 'https://www.homedepot.com/'],
      ],
      offersMenu: [
        ['Pro Xtra', 'https://www.homedepot.com/c/pro_xtra'],
        ['Credit Services', 'https://www.homedepot.com/myaccount/thdcreditcard'],
        ['Insurance Marketplace Offering', `${this.$runtimeConstants.SALESFORCE_ACCOUNT_REDIRECT_DOMAIN}/prohelpcenter/s/article/Insurance-Marketplace`],
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
 .TITLE {
    @include margin(3, 3);
    @include margin-left(-3);
    @include h3();
    font-weight: bold;
  }
  .SUB-TITLE {
    @include margin-bottom(2);
    @include margin-left(2);
    @include h5();
    font-weight: bold;
  }
  .INFO-LABEL {
    @include h6();
    @include margin(2,2);
    @include link-darker-blue;
    display: flex;
  }
  .INFO-CONTENT {
    @include margin-bottom(3);
  }
  .DIVIDER {
    width: 80%;
    border-top: 1px solid $color-gray60;
    @include tablet {
      display: block;
    }
  }
  .EXTERNAL-ICON {
    color: gray;
    align-self: center;
  }
</style>
